import { doPost, loadTemplateURL } from './utils';

export const loadTemplateDetails = async () => {
	// const subdomain = getSubdomain();
	// if (!window.userToken) return false;
	const result = await doPost(loadTemplateURL, {
		draft: true,
	});
	// console.log('TCL: checkValidToken -> result', result);
	if (result.error) {
		return {
			isValidToken: false,
		};
	}
	return {
		isValidToken: true,
		result,
	};
};

export const checkUserToken = async () => {
	const checkUserTokenURL = `${process.env.REACT_APP_BASE_API_URL}/private/rest/accounts/adviser_agent/check_website_user_token/`;
	const result = await doPost(checkUserTokenURL, {
		// token
	});
	console.log('TCL: checkUserToken -> result', result);
	if (result.error) {
		return {
			isValidToken: false,
		};
	}
	return {
		isValidToken: true,
		isSpecial: result.is_special,
		subdomain: result.subdomain,
	};
};

export const getTemplateMetas = async () => {
	const getTemplateMetasURL = `${process.env.REACT_APP_BASE_API_URL}/public/adviser/get_template_metas/`;
	const result = await doPost(getTemplateMetasURL, {
		branding_type: window.GM_BRANDING_TYPE,
	});
	console.log('TCL: getTemplateMetas -> result', result);
	return {
		template_metas: result.template_metas,
	};
};
